/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class OnboardingAzureResourceGroup {
  /**
  * The resource group resource ID
  */
  'id': string;
  /**
  * The subscription ID
  */
  'subscriptionId': string;
  /**
  * The tenant ID
  */
  'tenantId'?: string;
  /**
  * The resource group name
  */
  'name': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return OnboardingAzureResourceGroup.attributeTypeMap;
  }

  public constructor() {
  }
}

